import React, { useEffect, useState } from "react"
import MainContainer from "../../components/MainContainer"
import { Box, Button, Card, Grid2, IconButton, Typography } from "@mui/material"
import MainHeader from "../../components/MainHeader"
import Title from "../../components/Title"
import MainHeaderButtonsWrapper from "../../components/MainHeaderButtonsWrapper"
import AddIcon from "@mui/icons-material/Add"
import api from "../../services/api"
import { toast } from "react-toastify"
import ModalProduct from "../../components/ModalProduct"

import EditIcon from "@mui/icons-material/Edit"
import DeleteIcon from "@mui/icons-material/Delete"
import { fCurrency } from "../../utils/formatNumbers"
import ModalConfirm from "../../components/ModalConfirm"

function Products() {
    const [products, setProducts] = useState([])
    const [selectedProduct, setSelectedProduct] = useState(null)
    const [openModalDelete, setOpenModalDelete] = useState(false)

    const [openModal, setOpenModal] = useState(false)

    async function getProducts() {
        try {
            const res = await api.get("/products")
            setProducts(res.data)
        } catch (error) {
            toast.error("Erro ao buscar produtos")
        }
    }

    useEffect(() => {
        getProducts()
    }, [])

    const handleCloseModal = () => {
        setOpenModal(false)
        setSelectedProduct(null)
        getProducts()
    }

    const handleNewProduct = () => {
        setOpenModal(true)
    }

    const handleEdit = (productId) => {
        setSelectedProduct(productId)
        setOpenModal(productId)
    }

    const handleDelete = (productId) => {
        setSelectedProduct(productId)
        setOpenModalDelete(true)
    }

    const handleConfirmDeleteProduct = async () => {
        try {
            await api.delete(`/products/${selectedProduct}`)

            setOpenModalDelete(false)
            setSelectedProduct(null)

            getProducts()

            toast.success("Produto excluido com sucesso")
        } catch (error) {
            toast.error("Erro ao excluir produto")
        }
    }

    // TODO: excluir produtos
    // Adicionar seleção de produto no Ticket
    // E depois fazer a funcionalidade de formulários

    return (
        <MainContainer>
            <ModalConfirm
                title="Excluir produto?"
                description="Esta ação não pode ser desfeita"
                open={openModalDelete}
                onApprove={handleConfirmDeleteProduct}
                onCancel={() => {
                    setSelectedProduct(null)
                    setOpenModalDelete(false)
                }}
            />
            <ModalProduct
                open={openModal}
                handleClose={handleCloseModal}
                productId={selectedProduct}
            />
            <MainHeader>
                <Title>Produtos</Title>
                <MainHeaderButtonsWrapper>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={handleNewProduct}
                        startIcon={<AddIcon />}
                    >
                        Novo produto
                    </Button>
                </MainHeaderButtonsWrapper>
            </MainHeader>

            <Grid2 spacing={2} container>
                {products.map((product) => (
                    <Grid2
                        key={product.id}
                        size={{
                            xs: 12,
                            sm: 6,
                            md: 4,
                            lg: 3,
                        }}
                    >
                        <Card>
                            {!!product.medias?.length && (
                                <img
                                    src={product.medias[0].fileFullURL}
                                    width="100%"
                                    height="150px"
                                    style={{
                                        objectFit: "cover",
                                    }}
                                />
                            )}
                            <Box padding={2} position="relative">
                                <Box position="absolute" top={0} right={0}>
                                    <IconButton
                                        onClick={() => handleEdit(product.id)}
                                    >
                                        <EditIcon />
                                    </IconButton>
                                    <IconButton
                                        onClick={() => handleDelete(product.id)}
                                    >
                                        <DeleteIcon />
                                    </IconButton>
                                </Box>

                                <Box display="flex" flexDirection="column">
                                    <Typography variant="h6">
                                        {product.name}
                                    </Typography>
                                    <Typography variant="caption">
                                        {fCurrency(product.price)}
                                    </Typography>
                                    <Typography variant="caption">
                                        {product.description}
                                    </Typography>
                                </Box>
                            </Box>
                        </Card>
                    </Grid2>
                ))}
            </Grid2>
        </MainContainer>
    )
}

export default Products
